import Gambar1 from "../../assets/proyek1.png";
import Gambar2 from "../../assets/proyek2.png";
import Gambar3 from "../../assets/proyek3.png";
import Gambar4 from "../../assets/proyek4.png";
import Gambar5 from "../../assets/proyek5.png";
import Gambar6 from "../../assets/proyek6.png";
import Gambar7 from "../../assets/proyek7.png";
import Gambar8 from "../../assets/proyek8.png";
import Gambar9 from "../../assets/proyek9.png";
import Gambar10 from "../../assets/proyek10.png";
import Gambar11 from "../../assets/proyek11.png";
import Gambar12 from "../../assets/proyek12.png";
import Gambar13 from "../../assets/proyek13.png";
import Gambar14 from "../../assets/proyek14.png";
import Gambar15 from "../../assets/proyek15.png";
import Gambar16 from "../../assets/proyek16.png";
import Gambar17 from "../../assets/proyek17.png";
import Gambar18 from "../../assets/proyek18.png";
import Gambar19 from "../../assets/proyek19.png";
import Gambar20 from "../../assets/proyek20.png";
import Gambar21 from "../../assets/proyek21.png";
import Gambar22 from "../../assets/proyek22.png";
import Gambar23 from "../../assets/proyek23.png";

export const dataProyek = [

  // Data Science
  {
    id: 1,
    gambar: Gambar1,
    nama: "MSIB MIKTI Challange 2",
    kategori: "Data Science",
    tautan: "https://colab.research.google.com/drive/1SOojxqiw738j2_xiAyDrOXr57tk7acAM?usp=sharing",
  },
  {
    id: 2,
    gambar: Gambar2,
    nama: "MSIB MIKTI Challange 3",
    kategori: "Data Science",
    tautan:
      "https://colab.research.google.com/drive/1YzB9owFA8h6EMhUItiwKAKhKXdk20jGZ?usp=sharing",
  },
  {
    id: 3,
    gambar: Gambar3,
    nama: "Machine-learning-K-means",
    kategori: "Data Science",
    tautan:
      "https://colab.research.google.com/drive/19J6gztAKDJjiSWvA4et7KUgh0KoiH7Tp?usp=sharing",
  },
  {
    id: 4,
    gambar: Gambar4,
    nama: "MIKTI MSIB - DEMO - Regression - 13052024.",
    kategori: "Data Science",
    tautan:
      "https://colab.research.google.com/drive/1IXa7pYH9YGzKx10-y6LACXdzGepUREFC?usp=sharing",
  },
  {
    id: 5,
    gambar: Gambar5,
    nama: "MIKTI MSIB - Study Case - Covid-19",
    kategori: "Data Science",
    tautan:
      "https://colab.research.google.com/drive/1qETR_C3rQ5rwjIf1SL6YiQdh6fGmx-rE?usp=sharing",
  },
  {
    id: 6,
    gambar: Gambar6,
    nama: "MIKTI MSIB - Dashboard - Covid-19 - Google Looker Studio",
    kategori: "Data Science",
    tautan: "https://lookerstudio.google.com/reporting/f0d34697-8285-4ea8-a43a-131cfb5dcac3",
  },
  {
    id: 7,
    gambar: Gambar7,
    nama: "Project: Market Basket Analysis(MySkill)-Ian Mikhael.ipynb",
    kategori: "Data Science",
    tautan: "https://colab.research.google.com/drive/1NmmWIQgAx5-5_iLKFNlX7m-p20hrVPXB?usp=sharing",
  },
  {
    id: 8,
    gambar: Gambar8,
    nama: "Use Case - User Segmentation (MySkill) - Ian Mikhael.ipynb",
    kategori: "Data Science",
    tautan: "https://colab.research.google.com/drive/1WZdy2J9aTXOQXZcNqQAQE7W1mLwXiHXD?usp=sharing",
  },
  {
    id: 9,
    gambar: Gambar9,
    nama: "Use Case - User Retention Analysis MySkill - Ian Mikhael.ipynb",
    kategori: "Data Science",
    tautan: "https://colab.research.google.com/drive/1qIxa5In7CCKhxqZJUK-Jl6WkGZ0mnI8e?usp=sharing",
  },
  {
    id: 10,
    gambar: Gambar10,
    nama: "Klasterisasi Pelanggan Mall (Practice)",
    kategori: "Data Science",
    tautan: "https://colab.research.google.com/drive/1ODISHmFHYzgg8yS9vclp2TbKFIXTd3zx?usp=sharing",
  },

  //website
  {
    id: 11,
    gambar: Gambar11,
    nama: "Tokobuku - Output matakuliahSistem Informasi berbasis Web",
    kategori: "Website",
    tautan: "https://siweb211711553.000webhostapp.com/login",
  },
  {
    id: 12,
    gambar: Gambar12,
    nama: "Sihand ( Sistem Informasi HandBarberstop ) - Output matakuliah Proyek Analisis dan Desain Sistem Informasi",
    kategori: "Website",
    tautan: "https://sihand.my.id/",
  },
  {
    id: 13,
    gambar: Gambar13,
    nama: "Rumah Kuliner Wong Kito Galo - Output Lomba UI/UX Iweek Himsi (Wordpress)",
    kategori: "Website",
    tautan: "https://timklandestin.sihand.my.id/",
  },
  {
    id: 14,
    gambar: Gambar14,
    nama: "Website Portofolio Pribadi",
    kategori: "Website",
    tautan:
      "",
  },

  // UI/UX
  {
    id: 15,
    gambar: Gambar13,
    nama: "Rumah Kuliner Wong Kito Galo - Output Lomba UI/UX Iweek Himsi (Wordpress)",
    kategori: "UI/UX",
    tautan: "https://github.com/fifovalle/UI-PEMUAT.git",
  },
  {
    id: 16,
    gambar: Gambar16,
    nama: "Filmy - Output Lomba Ifest MUC UI/UX 2024",
    kategori: "UI/UX",
    tautan: "https://www.figma.com/proto/Cwbt62qmlcfCTHXBrAJ17o/Filmy?node-id=5-12495&starting-point-node-id=6%3A13037",
  },

  // Desain
  {
    id: 17,
    gambar: Gambar17,
    nama: "Jersey Futsal SMETSA Palembang",
    kategori: "Design",
    tautan: "https://drive.google.com/file/d/1GPcce9_JU2NpCcpZ8PV-bERkb1cHSCJe/view",
  },
  {
    id: 18,
    gambar: Gambar18,
    nama: "Jersey Futsal GBIP IMMANUEL PALEMBANG",
    kategori: "Design",
    tautan: "https://drive.google.com/file/d/1ZNtyURzSQ6PhxdQTgb_khDzwtrtM6aAO/view",
  },
  {
    id: 19,
    gambar: Gambar19,
    nama: "Poster Hari Buruh Nasional - Output Lomba Poster 2024 diadakan oleh HIMAAP FISIP UGJ",
    kategori: "Design",
    tautan: "https://drive.google.com/file/d/1o8oxn2h0DTzrUSEmm7ebrul3vJB-OMOh/view",
  },
  {
    id: 20,
    gambar: Gambar20,
    nama: "Feed Instagram Nujo67_kkn85 UAJY",
    kategori: "Design",
    tautan: "https://www.instagram.com/nujo67_kkn85/",
  },
  {
    id: 21,
    gambar: Gambar21,
    nama: "Logo Kelompok Nujo67_Kkn85 UAJY",
    kategori: "Design",
    tautan: "https://www.instagram.com/nujo67_kkn85/",
  },
  {
    id: 22,
    gambar: Gambar22,
    nama: "Feed Instagram - RNC FUTSAL FTI GOES TO SEMARANG (PIALA HUKUM UNDIP 2023)",
    kategori: "Design",
    tautan: "https://www.instagram.com/futsalftiuajy/",
  },
  {
    id: 23,
    gambar: Gambar15,
    nama: "Logo FTI FUTSAL LEAGUE 2023 UAJY",
    kategori: "Design",
    tautan: "https://www.instagram.com/p/CynaGRKhOYN/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
  },
  {
    id: 24,
    gambar: Gambar23,
    nama: "Feed Instagram & Logo - Jasa Web UI/UX",
    kategori: "Design",
    tautan: "https://www.instagram.com/jasawebuiux/",
  }
];

export const navigasiProyek = [
  {
    nama: "Semua",
  },
  {
    nama: "Data Science",
  },
  {
    nama: "Website",
  },
  {
    nama: "UI/UX",
  },
  {
    nama: "Design",
  },

];
